import {copyObject} from './components/Myfunctions.js'

export function filterBeers(beersList, filter){
    var searchResults=[]

    var cat=""
    if(('cat' in filter)&&filter.cat.length>0) cat=filter.cat

    var containers=[]
    if('containers' in filter) containers=filter.containers
    var price={}
    if('price' in filter) price=filter.price
    var styles=[]
    if('styles' in filter) styles=filter.styles

    //Copy the array to remove reactivity
    for (var i=0; i<beersList.length; i++) searchResults.push(copyObject(beersList[i]))

    if(cat.length>0){
        searchResults=filterCats(searchResults, cat)
    }
    
    if(containers.length>0){
        searchResults=filterContainers(searchResults, containers)
    } 
    if(price.min>0||price.max<1000){
        searchResults=filterPrice(searchResults, price)
        //console.log(searchResults)
    }

    if(styles.length>0){
        console.log("Filtering style")
        searchResults=filterStyles(searchResults, styles)
        //console.log(searchResults)
    }
    return searchResults

}

//Filter by drink category
function filterCats(beersList, cat){
    //Either beer style or categorcy contains cat
    var filteredArray=[]
    var catToCheck=cat.toLowerCase()
    for (var i=0; i<beersList.length; i++){
        var thisBeer=beersList[i]
        var thisBeerCat=thisBeer.cat.toLowerCase()
        if(thisBeerCat.includes(catToCheck)) filteredArray.push(thisBeer)

    }
    return filteredArray

}


//Filter by containers
function filterContainers(beersList, containers){
    //Return complete array if nothing in containers
    if(containers.length<=0) return beersList
    var filteredArray=[]

    for (var i=0; i<beersList.length; i++){
        var thisBeer=beersList[i]
            //Check barrels
            if(containers.includes('Barrels')){
                if(thisBeer.barrel1Quantity||thisBeer.barrel2Quantity) {
                    filteredArray.push(thisBeer) 
                    continue
                }
            }
            if(containers.includes('Cans')){
                if(thisBeer.canQuantity){
                    filteredArray.push(thisBeer)
                    continue

                } 
            }
            if(containers.includes('Bottles')){
                if(thisBeer.bottleQuantity){
                    filteredArray.push(thisBeer)
                    continue
                } 
            }

        
    }
    //End of looping over beers
    return filteredArray
}

//Filter by price
function filterPrice(beersList, price){
    var filteredArray=[]
    var minPrice=0
    var maxPrice=10000


    if('min' in price) minPrice=price.min
    if('max' in price) maxPrice=price.max

    console.log("Max = " + maxPrice)
    console.log("Min = "+ minPrice)

    //If minprice <=0 or maxprice>=1000, return complete list
    if(minPrice<=0&&maxPrice>=1000){
        return beersList
    } 

    for (var i=0; i<beersList.length; i++){
        var thisBeer=beersList[i]
        //Check non multisize
        if(!(thisBeer.multiSize==1)){
            if(parseInt(thisBeer.cost)<minPrice||parseInt(thisBeer.cost)>maxPrice) continue
            else {
                //Check if already exists in list
                const existingBeerindex = filteredArray.findIndex(item => item.id === thisBeer.id);
                if(existingBeerindex<0) filteredArray.push(thisBeer)
                continue
            }
        }

        else{
            //Check multi size
            //Check min price
            if(thisBeer.barrel1Cost&&parseInt(thisBeer.barrel1Cost)<minPrice) continue
            if(thisBeer.barrel2Cost&&parseInt(thisBeer.barrel2Cost)<minPrice) continue
            if(thisBeer.canCost&&parseInt(thisBeer.canCost)<minPrice) continue
            if(thisBeer.bottleCost&&parseInt(thisBeer.bottleCost)<minPrice) continue

            //Check max price
            if(thisBeer.barrel1Cost&&parseInt(thisBeer.barrel1Cost)>maxPrice) continue
            if(thisBeer.barrel2Cost&&parseInt(thisBeer.barrel2Cost)>maxPrice) continue
            if(thisBeer.canCost&&parseInt(thisBeer.canCost)>maxPrice) continue
            if(thisBeer.bottleCost&&parseInt(thisBeer.bottleCost)>maxPrice) continue
            console.log("Adding")
            console.log(thisBeer)

            //Meets criteria, add
            //Check if already exists in list
            const existingBeerindex = filteredArray.findIndex(item => item.id === thisBeer.id);
            if(existingBeerindex<0) filteredArray.push(thisBeer)
        }

    }
    return filteredArray

}

//Filter by styles
function filterStyles(beersList, styles){

    //Return complete array if nothing in styles
    if(styles.lenght<=0) return beersList

    var filteredArray=[]
    
    //Iterate over all styles
    for(var i=0; i<styles.length; i++){
        var thisStyle=styles[i]
        //Break search term into individual strings
        var styleArray = thisStyle.split(" ")
        var stringArray = new Array()
        for(var j =0; j < styleArray.length; j++){
            stringArray.push(styleArray[j].toLowerCase())
        }
        //Now we have stringArray, which is the style broken up into individual terms
        //Iterate over all beers and find ones which have style or substyle
        for (var k=0; k<beersList.length; k++){
            var thisBeer=beersList[k]
            var searchTermsFound=0
            var thisBeerStyle=thisBeer.type.toLowerCase()
            //Check if in type
            for (var l=0; l<stringArray.length; l++){
                if(thisBeerStyle.includes(stringArray[l])){
                    searchTermsFound=searchTermsFound+2
                    thisBeer.searchTermsFound=searchTermsFound
                    //Check if already exists in list
                    const existingBeerindex = filteredArray.findIndex(item => item.id === thisBeer.id);
                    if(existingBeerindex<0) filteredArray.push(thisBeer)
                    continue
                }
            }
            //Check if in subType
            if(thisBeer.subType){
                var thisBeerSubStyle=thisBeer.subType.toLowerCase()
                for (var l=0; l<stringArray.length; l++){
                    if(thisBeerSubStyle.includes(stringArray[l])){
                        searchTermsFound=searchTermsFound+2
                        thisBeer.searchTermsFound=searchTermsFound
                        //Check if already exists in list
                        const existingBeerindex = filteredArray.findIndex(item => item.id === thisBeer.id);
                        //If already exists, replace to increment count of search terms found
                        if(existingBeerindex<0) filteredArray.push(thisBeer)
                        else filteredArray.splice(existingBeerindex, 1, thisBeer)
                        continue
                    }
                }
            }
            //End of subType
        }
        //End of iterating over beers list
    }
    //End of iterating over styles
    //Sort on search terms found
    function compare(a, b) {
        const costA = a.searchTermsFound;
        const costB = b.searchTermsFound;

        let comparison = 0;
        if (costA <costB) {
                comparison = 1;
        } else if (costA>costB) {
                comparison = -1;
        }
            return comparison;
    }
    filteredArray.sort(compare);
        return filteredArray

}

